import React from "react";
import { Link, withRouter } from 'react-router-dom';
import { Menu } from 'antd';
import getMenus from '../router/config';
import { canAccessPerformance } from '@/utils/auth';
import { getLoginSupplierId } from '../utils/uploadResultAB';
import {
  ShoppingCartOutlined,
  HomeOutlined,
  UserOutlined,
  ProjectOutlined,
  PicLeftOutlined,
  UserSwitchOutlined,
  BookOutlined,
  DotChartOutlined,
  AccountBookOutlined,
} from '@ant-design/icons';

const SAMPLE_COLLECTION_PHOTO_SUPPLIER_IDS = ['1493'];

class SlideMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openKeys: [],
      selectedKeys: [],
      // 图标列表
      iconlists: {
        order: <ShoppingCartOutlined />,
        user: <UserOutlined />,
        home: <HomeOutlined />,
        project: <ProjectOutlined />,
        platform: <PicLeftOutlined />,
        visitor: <UserSwitchOutlined />,
        caseLibrary: <BookOutlined />,
        dataAnalysisProduct: <DotChartOutlined />,
        costRegistration: <AccountBookOutlined />,
      }
    };
  }

  /** 获取指定名称的 cookie 值 */
  getCookie = (name) => {
    const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
    const match = reg.exec(document.cookie);
    if (match?.[2]) {
      try {
        return decodeURIComponent(match[2]);
      } catch (e) {
        return match[2];
      }
    }
    return '';
  };

  /** 获取三方/自营权限 */
  getCookieProprietary = () => {
    return this.getCookie('proprietary');
  };

  /** 获取代运营权限 */
  getIsAgencyOperation = () => {
    return this.getCookie('is_agency_operation');
  };

  /** 获取当前角色权限 */
  getRole = () => {
    return this.getCookie('roleid');
  };

  openChange = (data) => {
    this.setState({
      openKeys: data
    })
  }

  renderMenuItem = ({ key, icon, title }) => {
    const roleId = this.getRole();
    const proprietary = this.getCookieProprietary();
    // 非超级管理员
    const isSuperAdmin = roleId == 1;
    // 三方供应商非超级管理员不展示菜单列表
    const notSuperAdminKeys = [
      '/settlement-management',
    ];
    // 三方供应商不展示的菜单列表
    const keys = [
      '/performance',
      '/sendSampleOrder',
      '/visitor',
      '/caselibrary',
      '/instrumentManagement/allInstrumentList',
      '/instrumentManagement/scheduleList',
      '/instrumentManagement/operateLog',
      '/instrumentManagement/maintenanceList',
      '/instrumentManagement/maintenanceRecord',
      '/instrumentManagement/maintenanceDetail',
      '/instrumentManagement/buffetDetail',
      '/instrumentManagement/instrumentList',
    ];
    if (roleId == 3 && key === '/testProject') return;
    if (key === '/performance' && !canAccessPerformance(proprietary)) return;
    if (!isSuperAdmin && notSuperAdminKeys.includes(key)) {
      return;
    }
    if (proprietary === '1' && key === '/order/settle') { return };
    if (proprietary === '0' && keys.includes(key)) { return };
    // 只对代运营供应商（is_agency_operation = 1） 展示实验成本登记菜单
    if (key === '/experiment-cost-registration' && this.getIsAgencyOperation() !== '1') {
      return;
    }
    return (
      <Menu.Item key={key} icon={this.state.iconlists[icon]}>
        <Link to={key}>{title}</Link>
      </Menu.Item>
    )
  }

  renderSubMenu = ({ key, icon, title, subs }) => {
    const proprietary = this.getCookieProprietary();
    const canAccessSampleCollectionPhoto = proprietary !== '0'
      || SAMPLE_COLLECTION_PHOTO_SUPPLIER_IDS.includes(getLoginSupplierId());
    if (this.getRole() == 3 && key === '/user') return;
    if ((this.getRole() == 3 || this.getRole() == 2) && key === '/user/settlement') return;
    // 三方供应商不展示案例库菜单
    if (this.getCookieProprietary() === '0' && key === '/caselibrary') {
      return
    };
    return (
      <Menu.SubMenu key={key} title={title} icon={this.state.iconlists[icon]}>
        {
          subs && subs.map(item => {
            item.hidden = false;
            if (this.getRole() == 2 || this.getRole() == 3) {
              if (item.key === '/user/index') {
                item.hidden = true;
              }
            }
            if (this.getCookieProprietary() == 1) {
              if (item.key === '/order/recovery') {
                item.hidden = true;
              }
            } else if (this.getCookieProprietary() == 0) {
              if (item.key === '/order/sample') {
                item.hidden = true;
              }
            }
            if (!canAccessSampleCollectionPhoto) {
              if (item.key === '/order/scanQRcode') {
                item.hidden = true;
              }
            }
            if (item.hidden) return;
            return item.subs && item.subs.length > 0 ? this.renderSubMenu(item) : this.renderMenuItem(item)
          })
        }
      </Menu.SubMenu>
    )
  }

  /** 处理侧边栏 */

  render() {
    return (
      <div>
        <div className="logo">{this.props.collapsed ? '' : '研趣供应商管理平台'}</div>
        <Menu
          defaultOpenKeys={this.state.openKeys}
          openKeys={this.state.openKeys}
          defaultSelectedKeys={this.state.selectedKeys}
          selectedKeys={[this.props.history.location.pathname]}
          theme="dark"
          mode='inline'
          onOpenChange={this.openChange}>
          {
            getMenus().map(item => {
              return item.subs && item.subs.length > 0 ? this.renderSubMenu(item) : this.renderMenuItem(item)
            })
          }
        </Menu>
      </div>
    )
  }
}

export default withRouter(SlideMenu);
